import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import common from './common';
import auth from './auth';
import users from './users';
import personal from './personal';
import products from './products';
import posts from './posts';
import uploads from './uploads';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    common,
    auth,
    users,
    personal,
    products,
    posts,
    uploads,
  },
  plugins: [createPersistedState({
    key: 'vuex-zaiko',
  })],
});
